import React from "react";
import PropTypes from "prop-types";

import styles from "./floatingButton.css";

import FloatingUpArrowIcon from "@/common/icons/FloatingUpArrow.svg";

FloatingButton.propTypes = {
  scrollRef: PropTypes.object,
  hideFloating: PropTypes.func
};

export function FloatingButton({ scrollRef, hideFloating }) {
  function scrollToTop() {
    scrollRef.current.scrollToTop();
    hideFloating();
  }

  return (
    <div className={styles.floatingButton} onClick={scrollToTop}>
      <FloatingUpArrowIcon />
    </div>
  );
}
